import React from 'react';

// Production front door: explains how to open a report. Accepts no input,
// so it cannot be misused and never shows an internal-looking form. Real
// students arrive via a MyIMS deep link (token in the URL) and never see `/`;
// the dev paste/PIN form is gated to localhost in HomePage.
const OpenFromMyIMS = () => (
  <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
    <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center">
      <h1 className="text-xl font-bold text-gray-800 mb-2">IIMB UG AT AI Insights</h1>
      <p className="text-gray-600">
        Your report opens from the MyIMS app — tap the <strong>AI Insights</strong> link
        for your test there.
      </p>
    </div>
  </div>
);

export default OpenFromMyIMS;
